import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/how-to-make-hiking-stick';

class HowToMakeHikingStick extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>How to Make a Hiking Stick With Just a Knife (Step-by-Step Guide)</title>
          <meta name="description" content="Learn how to make a hiking stick with just a knife in this easy beginner guide. Choose the right wood, cut it to size, shape the tip, and create a simple grip for the trail." />
          <meta property="og:title" content="How to Make a Hiking Stick With Just a Knife" />
          <meta property="og:description" content="Learn how to make a hiking stick with just a knife in this easy beginner guide. Choose the right wood, cut it to size, shape the tip, and create a simple grip for the trail." />
          <meta property="og:url" content="https://exploroff.com/hiking-guides/how-to-make-hiking-stick" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/how-to-make-a-hiking-stick/how-to-make-a-hiking-stick.webp" />
          <link rel="canonical" href="https://exploroff.com/hiking-guides/how-to-make-hiking-stick" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "How to Make a Hiking Stick With Just a Knife",
            description: "Learn how to make a hiking stick with just a knife in this easy beginner guide.",
            image: ["https://exploroff.com/img/how-to-make-a-hiking-stick/how-to-make-a-hiking-stick.webp"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/hiking-guides/how-to-make-hiking-stick" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="How to Make a Hiking Stick With Just a Knife"
          category="hiking-guides"
          slug="how-to-make-hiking-stick"
          excerpt="Choose the right wood, shape the tip, and create a grip for the trail with just a knife."
          tags={['gear', 'beginner', 'trail tips']}
          readTime={6}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default HowToMakeHikingStick;
